module.exports = __webpack_public_path__ + "media/Images/WomanOnComputerSmiling-349cc07e144350ec3bc51fd5f68e5f85.png";